<template>
  <b-form-checkbox
    :id="'status-switch-' + id"
    v-model="localActive"
    :name="'status-switch-' + id"
    switch
    inline
    class="custom-switch-color mb-0"
    color="primary"
    @change="emitStatusChange"
  />
</template>
<script>
export default {
  props: {
    status: {
      type: [String, Number, Boolean]
    },
    type: {
      type: String
    },
    id: {
      required: true
    },
    statusKeyId: {
      type: String,
      default: ''
    },
    allData: {
      required: true
    }
  },
  data () {
    return {
      localActive: false
    }
  },
  watch: {
    status: {
      immediate: true,
      handler (v) {
        this.localActive = v === 'active' || v === 1 || v === '1' || v === true
      }
    }
  },
  methods: {
    emitStatusChange () {
      const obj = {
        status: this.localActive ? 'active' : 'inactive',
        type: this.type
      }
      if (this.statusKeyId) {
        obj[this.statusKeyId] = this.id
      }
      this.$emit('changeStatus', { payload: obj, data: this.allData })
    }
  }
}
</script>
